module.exports = __webpack_public_path__ + "static/media/Акманова С..e5bb6b88.pdf";